import { useTranslation } from "react-i18next";
import { X } from "lucide-react";

const LANGUAGES = [
  { code: "en", labelKey: "language.en" },
  { code: "mr", labelKey: "language.mr" },
  { code: "hi", labelKey: "language.hi" },
];

export default function LanguageDialog({ open, onClose }) {
  const { t, i18n } = useTranslation();

  const select = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem("app_lang", code);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/40 flex items-end md:items-center justify-center">
      <div className="bg-white w-full max-w-sm rounded-t-2xl md:rounded-2xl p-5 animate-in slide-in-from-bottom md:zoom-in-95">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-lg font-semibold text-[#1A1D1A]">{t("language.title")}</h3>
          <button onClick={onClose} className="w-8 h-8 grid place-items-center rounded-full hover:bg-[#F3F1ED]">
            <X size={18} />
          </button>
        </div>
        <div className="space-y-1">
          {LANGUAGES.map(({ code, labelKey }) => (
            <button
              key={code}
              onClick={() => select(code)}
              className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl text-left transition-all ${
                i18n.language === code ? "bg-[#1C4532] text-white" : "bg-[#FAF9F6] text-[#1A1D1A] active:bg-[#F3F1ED]"
              }`}
            >
              <span className="flex-1 text-sm font-medium">{t(labelKey)}</span>
              {i18n.language === code && (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
